import {
  NOTIFICATION_SOURCE_SERVICE,
  NOTIFICATION_TYPE_MESSAGE,
  NOTIFICATION_TYPE_RECRUIT,
  NOTIFICATION_TYPE_SYSTEM,
} from '@/shared/constants/notificationConstants';
import { DEFAULT_USER_IMAGE } from '@/shared/constants/userConstants';
import { modifyTime } from '@/shared/utils/modifyTime';
import {
  NOTIFICATION_MESSAGE_SUBTITLE,
  NOTIFICATION_RECRUIT_SUBTITLE,
} from '@/features/Notifications/lib/notificationsMessages';
import type {
  NotificationApiItem,
  NotificationWithId,
} from '@/features/Notifications/model/types/notifications';

export const isSystemNotification = (item: NotificationApiItem): boolean =>
  item.source_user_id === NOTIFICATION_SOURCE_SERVICE &&
  item.type === NOTIFICATION_TYPE_SYSTEM;

export const isSupportedNotification = (item: NotificationApiItem): boolean =>
  isSystemNotification(item) ||
  item.type === NOTIFICATION_TYPE_MESSAGE ||
  item.type === NOTIFICATION_TYPE_RECRUIT;

export const mapNotification = (item: NotificationApiItem): NotificationWithId => {
  const { text, type, options, source, id } = item;
  const roomId = options?.room_id || null;
  const roomLink = roomId ? `/cabinet/chat/${roomId}` : '';

  if (isSystemNotification(item)) {
    return {
      id,
      roomId,
      title: text,
      iconName: 'JurikServiceLogo',
      link: roomLink,
      subtitle: '',
      time: '',
      profilePhotoUrl: '',
    };
  }

  const sourceUser = options?.source_user;
  const isRecruit = type === NOTIFICATION_TYPE_RECRUIT;
  const senderName = `${sourceUser?.name || ''} ${sourceUser?.surname || ''}`.trim();

  return {
    id,
    roomId,
    title: (isRecruit ? source?.lawyer?.company?.name : senderName) || text,
    subtitle: isRecruit ? NOTIFICATION_RECRUIT_SUBTITLE : NOTIFICATION_MESSAGE_SUBTITLE,
    profilePhotoUrl: sourceUser?.avatar || source?.avatar || DEFAULT_USER_IMAGE,
    time: sourceUser?.created_at ? modifyTime(sourceUser.created_at) : '',
    iconName: '',
    link: type === NOTIFICATION_TYPE_MESSAGE ? roomLink : '',
  };
};
